import { useState } from "react";
import { Button } from "react-bootstrap";
import StudentTable from "./StudentTable";
import img1 from "../../../../assets/img/teacherDashboard/DashboardImg1.png";
import img2 from "../../../../assets/img/teacherDashboard/DashboardImg2.png";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";
import { useGetDummyStudent } from "../../../../hooks/school/student/useGetDummyStudent";
import { useSwitchDummyStudent } from "../../../../hooks/school/student/useSwitchDummyStudent";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import DeleteModal from "../../../common/DeleteModal";

const Dashboard = () => {
  const navigate = useNavigate();

  // Explore Student Flow state
  const [showExploreModal, setShowExploreModal] = useState(false);
  const [exploreLoading, setExploreLoading] = useState(false);
  const [exploreError, setExploreError] = useState("");
  const [exploreSuccess, setExploreSuccess] = useState(false);

  const { getDummyStudent } = useGetDummyStudent();
  const { switchDummyStudent } = useSwitchDummyStudent();
  const { login: tenantLogin } = useTenantAuth();

  const handleCreateClassroom = () => {
    navigate("/teacher/classroom/create");
  };

  return (
    <div className="classroom-cnt">
      {/* Banner with overlay content */}
      <div className="classroom-container">
        <img src={img1} alt="Dashboard Banner" className="banner-img" />

        <div className="dashboard-header">
          <div className="header-left">
            <img src={img2} alt="Dashboard" className="header-img" />
          </div>
          <div className="header-right">
            <div className="header-right-text">
              Teach your students about
              <p
                style={{
                  fontWeight: 500,
                }}
              >
                the Indian Culture
              </p>
            </div>

            <Button
              size="lg"
              onClick={handleCreateClassroom}
              className="create-classroom-btn"
            >
              Create Classroom
            </Button>
          </div>
        </div>
      </div>
      <div className="btn-container">
        <Button
          className="primary-btn"
          onClick={() => {
            navigate("/teacher/student/create");
          }}
        >
          Add Student
        </Button>
        <Button
          className="primary-btn"
          onClick={() => setShowExploreModal(true)}
          id="explore-student-flow-btn"
        >
          Explore Student Flow
        </Button>
      </div>
      <div>
        {/* Students Table */}
        <StudentTable />

      </div>

      {/* Explore Student Flow Confirmation Modal */}
      <DeleteModal
        showModal={showExploreModal}
        handleClose={() => {
          if (!exploreLoading) {
            setShowExploreModal(false);
            setExploreError("");
            setExploreSuccess(false);
          }
        }}
        handleDelete={async () => {
          try {
            setExploreLoading(true);
            setExploreError("");
            setExploreSuccess(false);

            // Step 1: Create / ensure the dummy student account exists
            await getDummyStudent();

            // Step 2: Switch to the dummy student session
            await switchDummyStudent((data) => {
              const user = data.user;
              user.auth = data.auth;
              user.is_dummy_student = true;
              tenantLogin(user, data.token);

              setExploreSuccess(true);
            });
          } catch {
            setExploreError(
              "Failed to switch to student account. Please try again.",
            );
          } finally {
            setExploreLoading(false);
          }
        }}
        loading={exploreLoading}
        error={exploreError}
        success={exploreSuccess}
        message="Are you sure you want to explore the student flow? You will be automatically logged out from this account and logged in as a student."
        successMessage="Switched to student account successfully. Redirecting..."
        customConfirmTitle="Explore Student Flow"
        customSuccessTitle="Switching Account"
        customErrorTitle="Switch Failed"
        customActionButtonText="Yes, Explore"
        customLoadingButtonText="Switching..."
        onSuccessContinue={() => {
          navigate("/student/start-your-quest");
        }}
      />
    </div>
  );
};

export default Dashboard;
